"use client";

import { Command } from "cmdk";
import { type ComponentProps } from "react";

import cn from "../../utils/cn.util";

export interface ComboboxGroupProps extends ComponentProps<typeof Command.Group> {}

const Group = ({ ref, className, children, ...props }: ComboboxGroupProps) => (
  <Command.Group
    ref={ref}
    className={cn(
      "text-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium",
      className
    )}
    {...props}
  >
    {children}
  </Command.Group>
);

Group.displayName = Command.Group.displayName;

export default Group;
